/**
 * Fallback após falha de renovação/retry em 401.
 * NÃO recarrega a página para não perder alterações não salvas do usuário.
 */
export function handleUnauthorizedRedirect(): void {
  console.warn(
    "[AUTH][401] Falha ao renovar/reexecutar request. Sessão permanece na tela atual."
  );
}
